import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoBas: CultureInfo = {
  name: 'bas',
  displayName: 'Ɓàsàa',
  iso3LanguageCode: 'bas',
  iso2LanguageCode: 'bas',
  ietfLanguageTag: 'bas',
  parent: null
};
